'use strict';

module.exports = function (ngModule) {
    ngModule.directive('appReplace', require('./appreplace'));
}


/** WEBPACK FOOTER **
 ** ./src/pages/directives/appreplace/index.js
 **/